import API from "../../../utils/api";

// slug is 'image-view-type' or 'image-shot-type' (generic settings/{slug} endpoints).
export const getImageTagTypesApi = async (slug, filters) => {
    const response = await API.get(`settings/${slug}`, { params: filters });
    return { response };
};

export const addImageTagTypeApi = async (slug, data) => {
    const response = await API.post(`settings/${slug}`, data);
    return { response };
};

export const updateImageTagTypeApi = async (slug, data, id) => {
    const response = await API.put(`settings/${slug}/${id}`, data);
    return { response };
};

export const deleteImageTagTypeApi = async (slug, id) => {
    const response = await API.delete(`settings/${slug}/${id}`);
    return { response };
};
